import { Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import CmsGallerySection from "../components/CmsGallerySection";
import { COMPANY } from "../data/siteData";
import { imageUrl } from "../lib/images";

export default function FoedevaretransportPage() {
  return (
    <div className="bg-[#070d18] text-slate-100 min-h-screen">
      <SEOHead
        title="Fødevaretransport"
        description="Pålidelig fødevare- og køletransport for producenter, grossister og måltidskassevirksomheder med faste distributionsruter."
      />

      {/* Hero Header */}
      <section className="relative pt-16 pb-20 lg:pt-24 lg:pb-28 border-b border-slate-800 bg-[#081120] overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-6">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#0F766E]/20 border border-[#2DD4BF]/40 text-[#2DD4BF] text-xs font-mono uppercase tracking-widest">
              <i className="fa-solid fa-utensils text-[10px]" aria-hidden="true" />
              <span>Ydelse · B2B Fødevaretransport</span>
            </div>

            <h1 className="text-3xl sm:text-5xl font-extrabold text-white tracking-tight leading-tight font-display">
              Køletransport af fødevarer og måltidskasser
            </h1>

            <p className="text-base sm:text-lg text-slate-300 leading-relaxed">
              KVC Express ApS tilbyder køletransport af måltidskasser, kød, fisk og øvrige kølevarer i hele Danmark – inklusive Bornholm. Som underleverandør for Gordon Delivery leverer vi blandt andet måltidskasser fra HelloFresh, Factor, RetNemt og BetterFeast med fokus på korrekt temperatur, omhyggelig håndtering og levering til tiden.
            </p>

            <div className="pt-2 flex flex-wrap gap-4">
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-[#0F766E] hover:bg-[#115E59] active:bg-[#134E4A] text-white font-bold text-xs uppercase tracking-wider transition shadow-lg shadow-[#0F766E]/30 cursor-pointer"
              >
                <span>Tal med os om fødevaretransport</span>
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
              </Link>
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-slate-900 border border-slate-700 text-slate-200 hover:text-white font-semibold text-xs transition whitespace-nowrap"
              >
                <i className="fa-solid fa-phone text-[#2DD4BF]" aria-hidden="true" />
                <span className="whitespace-nowrap">Ring: {COMPANY.phone}</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Details Section */}
      <section className="py-20 bg-slate-100 text-slate-900 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Left Content */}
            <div className="lg:col-span-6 space-y-6">
              <div className="text-xs font-mono uppercase tracking-widest text-[#0F766E] font-bold">
                Erhvervsfokus
              </div>
              <h2 className="text-2xl sm:text-4xl font-extrabold text-slate-950 tracking-tight font-display">
                Fra produktion og terminal til modtageled
              </h2>
              <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
                Fødevarebranchen stiller strenge krav til kølekæden, hygiejne og leveringstider. Vores nye L2H2 kølevogne er indrettet specifikt til professionel transport, hvor varernes kvalitet bevares under hele turen.
              </p>
              <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
                Vi indgår transportaftaler med virksomheder og leverer til både erhvervs- og privatadresser med faste ruter og tidsfølsomme afleveringer – altid med fokus på faste transportaftaler og ubrudt køl.
              </p>

              <div className="space-y-3 pt-2">
                <div className="p-4 rounded-xl bg-white border border-slate-200/90 shadow-sm flex items-start gap-3.5">
                  <div className="w-8 h-8 rounded-lg bg-[#0F766E]/10 border border-[#0F766E]/20 flex items-center justify-center text-[#0F766E] shrink-0 mt-0.5">
                    <i className="fa-solid fa-box-open" aria-hidden="true" />
                  </div>
                  <div>
                    <div className="text-slate-900 font-bold text-sm">Måltidskasser (HelloFresh, BetterFeast, RetNemt, Factor)</div>
                    <div className="text-xs text-slate-600 mt-0.5">Gennemtestet distribution af måltidskasser til private modtagere med præcis tidsoverholdelse.</div>
                  </div>
                </div>
                <div className="p-4 rounded-xl bg-white border border-slate-200/90 shadow-sm flex items-start gap-3.5">
                  <div className="w-8 h-8 rounded-lg bg-[#0F766E]/10 border border-[#0F766E]/20 flex items-center justify-center text-[#0F766E] shrink-0 mt-0.5">
                    <i className="fa-solid fa-drumstick-bite" aria-hidden="true" />
                  </div>
                  <div>
                    <div className="text-slate-900 font-bold text-sm">Fersk kød (bl.a. Kødhuset) & fiskeprodukter</div>
                    <div className="text-xs text-slate-600 mt-0.5">Sikker transport af kød og fisk under striks temperaturkontrol.</div>
                  </div>
                </div>
                <div className="p-4 rounded-xl bg-white border border-slate-200/90 shadow-sm flex items-start gap-3.5">
                  <div className="w-8 h-8 rounded-lg bg-[#0F766E]/10 border border-[#0F766E]/20 flex items-center justify-center text-[#0F766E] shrink-0 mt-0.5">
                    <i className="fa-solid fa-map-location-dot" aria-hidden="true" />
                  </div>
                  <div>
                    <div className="text-slate-900 font-bold text-sm">Hele Danmark inkl. Bornholm</div>
                    <div className="text-xs text-slate-600 mt-0.5">Landsdækkende ruter – uddannede chauffører med bevis til varebil og kurser i kølekæde og hygiejne.</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="lg:col-span-6">
              <div className="rounded-2xl overflow-hidden border border-slate-300 bg-white shadow-xl">
                <img
                  src={imageUrl("/_assets/shutterstock-2664143269.jpg", "width=900,quality=85,format=auto")}
                  alt="KVC Express levering af fødevarer og måltidskasser direkte til modtager"
                  className="w-full h-80 sm:h-[450px] object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <CmsGallerySection
        gallerySlug="foedevaretransport"
        title="Fødevaretransport & logistik"
        subtitle="Billeder af moderne transportbiler til temperaturfølsomme fødevarer"
      />

      {/* Bottom CTA Block */}
      <section className="py-16 bg-[#050a14] border-t border-slate-800 text-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
          <h3 className="text-2xl sm:text-3xl font-bold text-white font-display">
            Søger jeres fødevarevirksomhed en stabil transportpartner?
          </h3>
          <p className="text-slate-300 text-sm sm:text-base max-w-xl mx-auto">
            Tag kontakt til KVC Express ApS og få en snak om faste distributionsaftaler.
          </p>
          <Link
            to="/kontakt"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl bg-[#0F766E] hover:bg-[#115E59] text-white font-bold text-xs uppercase tracking-wider transition shadow-xl shadow-[#0F766E]/40"
          >
            <span>Tal med os om fødevaretransport</span>
            <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
          </Link>
        </div>
      </section>
    </div>
  );
}
